import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function Industries() {
  const { t } = useLanguage();
  const ind = t.industries;

  return (
    <section id="industries" className="page-section bg-light">
      <div className="container">
        <ScrollReveal className="section-head center">
          <span className="section-eyebrow">{ind.eyebrow}</span>
          <div className="accent-line center" />
          <h2 className="section-title">{ind.title}</h2>
          <p className="section-sub">{ind.sub}</p>
        </ScrollReveal>
        <div className="industries-grid">
          {ind.items.map((item, i) => (
            <ScrollReveal key={item.img} delay={i * 40}>
              <div className="industry-card">
                <div className="ind-img">
                  <img src={`${process.env.PUBLIC_URL}/Assets/sector/${item.img}`} alt={item.name} />
                </div>
                <div className="ind-name">{item.name}</div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
